import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { Store } from '@ngxs/store';
import {
  AllocationViewCallToSecurityCheckAction,
  AllocationViewCallToSecurityCheckActionSetInitialState,
} from './allocation-view-call-to-arrival-security-action.actions';
import { AllocationViewCallToArrivalSecurityActionState } from './allocation-view-call-to-arrival-security-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewCallToArrivalSecurityActionFacade implements AllocationViewActionInterface {
  loaded$ = this.store.select(AllocationViewCallToArrivalSecurityActionState.getLoaded);

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  execute(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewCallToSecurityCheckAction({
            identifier,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewCallToSecurityCheckActionSetInitialState());
  }
}
